import type { WordListData, WordListEntry, WordListScanResult } from '@/teoCore/TeoApi';
import { TeoEventTarget } from '@/teoCore/utility/TeoEventTarget';

import type { TeoText } from '../TeoText';
import type { WordListHandler } from './WordListHandler';
import { WordListSubHandler } from './WordListSubHandler';

export type BrandFitHandlerEvents = {
  brandFitCheck: (pass: boolean | undefined) => void;
};
export const BrandFitCategories = ['replacements', 'checks'] as const;
export type BrandFitCategory = (typeof BrandFitCategories)[number];

export class BrandFitHandler extends WordListSubHandler {
  passed: boolean | undefined;
  constructor(wordLists: WordListHandler, text: TeoText) {
    super(
      wordLists,
      text,
      new TeoEventTarget<BrandFitHandlerEvents>(),
      'brand-scanner',
      'brandFitWordList',
      'brandFitCategory',
    );
    this.wordLists.events.addEventListener('gotScanResult', (result) => {
      if (this.text.core.dynamicConfig.options.brandFitEnabled) {
        this.handleScanResult(result);
      }
    });
  }

  getViolations(wordList: WordListData): WordListEntry[] {
    return wordList.current_text_entries.filter(
      (entry) =>
        entry.expressions.find((expression) => expression.id == entry.found_by)?.priority === 0,
    );
  }

  private handleScanResult = (result: WordListScanResult): void => {
    this.lists = [];
    result.word_lists.forEach((wordList) => {
      if (wordList.use_for_ct && wordList.relation_type !== 0) {
        this.lists.push(wordList);
      }
    });
    this.checkBrandFit();
    this.syncCurrentEntries();
  };

  private checkBrandFit(): void {
    if (!this.lists || this.lists.length === 0) {
      this.passed = undefined;
      this.events.triggerEvent('brandFitCheck', this.passed);
      return;
    }
    this.passed = true;
    outer: for (const wordList of this.lists) {
      for (const entry of wordList.current_text_entries) {
        if (
          entry.expressions.find((expression) => expression.id == entry.found_by)?.priority === 0
        ) {
          this.passed = false;
          break outer;
        }
      }
    }
    this.events.triggerEvent('brandFitCheck', this.passed);
  }
}
